export const DOCUMENT_ACCESS_GROUPS = {
  all: "all",
  trainees: "trainees",
  instructors: "instructors",
  funding_agencies: "funding_agencies",
  companies: "companies",
};

export const HOME_FOLDER_ID = undefined;
